/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Right-to-left~DB634",
		"timeZoneID": "Time zone~DB569",
		"skin": "Style~DB558",
		"metricsFileImportTask": "New Import from Files~DB616",
		"displayMode": "Default view~DB562",
		"credentialRenewed": "Your credentials were renewed with your current user ID and password.~DB598",
		"productLocale": "Product language~DB563",
		"credentialChange": "Renew~DB597",
		"log_level_Debug": "Debug~DB658",
		"unsavedViewMsg2": "Your changes will be lost if you don't save them first.~DB652",
		"confirmNewPassword": "Confirm new password~DB587",
		"supportPortalErrorMessage": "[Try again.  If the problem persists, contact your administrator.~DB644]",
		"legalText": "[Licensed Materials - Property of IBM Corp. �� Copyright IBM Corporation and other(s) 2005, [%{year}]. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.~DB556]",
		"groupsAndRoles": "Groups and roles~DB604",
		"metricsMaintenanceTask": "New Maintenance~DB617",
		"email": "Email~DB570",
		"contextual": "Contextual~DB636",
		"resetHome": "Reset to default~DB573",
		"ltr": "Left-to-right~DB635",
		"credentials": "Credentials~DB594",
		"logging_congfig_title": "Logging~DB662",
		"changePasswordTitle": "Change my password~DB583",
		"format": "Report format~DB560",
		"showUnread": "Show unread~DB638",
		"docsErrorMessage": "[Try again.  If the problem persists, contact your administrator.~DB642]",
		"homeSetError": "[An error occurred setting the default home page, try closing and reopening this view.~DB575]",
		"passwordChange": "Change your password~DB582",
		"pdfRestricted": "PDF (Restricted)~DB625",
		"drillThrough": "Drill-Through definitions~DB608",
		"homeSet": "Your home was set successfully~DB574",
		"regionalOptions": "Options for your region~DB568",
		"myPreferences": "My preferences~DB557",
		"defaultHome": "Default~DB572",
		"version": "Version~DB555",
		"controller": "Controller~DB613",
		"manage": "Manage~DB602",
		"biDirectionalFeaturesEnabled": "Bidirectional language support~DB565",
		"newFeaturesErrorTitle": "The link to New Features did not work~DB653",
		"passwordMatch": "Password match~DB588",
		"dashboardConsole": "Workspace~DB607",
		"legacyAppsSlideoutLabel": "Available Legacy Applications~DB649",
		"logging_config_description": "Logging is used for troubleshooting. Consult your administrator for guidance on settings.~DB661",
		"signInButtonText": "Sign in~DB651",
		"dataSourceCredentials": "Data server credentials~DB603",
		"spreadsheetMLRestricted": "Excel (Restricted)~DB627",
		"xlsxDataRestricted": "Excel Data (Restricted)~DB629",
		"advanced": "Advanced~DB593",
		"ok": "OK~DB620",
		"showHints": "Show hints~DB640",
		"general": "General~DB577",
		"xlsxData": "Excel Data~DB628",
		"personal": "Personal~DB578",
		"newPassword": "New password~DB586",
		"confirmPassword": "Confirm password~DB581",
		"hideAll": "Hide all~DB639",
		"metricStudio": "Studio~DB615",
		"supportPortalErrorTitle": "The link to Support Portal didn't work~DB643",
		"log_level_Warn": "Warning~DB656",
		"myCapabilities": "My capabilities~DB600",
		"homePage": "Home page~DB571",
		"helpErrorMessage": "[Try again.  If the problem persists, contact your administrator.~DB646]",
		"portal": "Portal~DB567",
		"metricsPackage": "New Package~DB619",
		"myCredentials": "My credentials~DB599",
		"credentialCreate": "Create~DB595",
		"eventStudio": "Event Studio~DB609",
		"updatePWUnknownError": "Unable to update password~DB591",
		"csv": "CSV~DB630",
		"showHiddenObjects": "Show hidden entries~DB559",
		"docsErrorTitle": "The link to Documentation didn't work~DB641",
		"log_level_Error": "Error~DB655",
		"wrongPassword": "Unable to authenticate~DB590",
		"productName": "[IBM Cognos Analytics with Watson[%{version}]~DB554]",
		"log_level_Info": "Information~DB657",
		"helpErrorTitle": "The link to Help didn't work~DB645",
		"contentLocale": "Content language~DB564",
		"pdf": "PDF~DB624",
		"oldPassword": "Old password~DB585",
		"spreadsheetML": "Excel~DB626",
		"accessibilityFeatures": "Turn on accessibility features~DB561",
		"manageLogging": "Logging~DB663",
		"loggingConfigurationSlideoutA11yLabel": "Logging Configuration~DB664",
		"communityErrorTitle": "The link to Community didn't work~DB647",
		"companionApps": "Companion applications~DB605",
		"metricsExportTask": "New Export~DB618",
		"csvRestricted": "CSV (Restricted)~DB631",
		"newFeaturesErrorMessage": "[Try again.  If the problem persists, contact your administrator.~DB654]",
		"contributor": "Contributor~DB614",
		"showAll": "Show all~DB637",
		"logging_active": "Logging is on:~DB660",
		"baseTextDirection": "Base direction for text~DB566",
		"html": "HTML~DB621",
		"queryStudio": "Query Studio~DB610",
		"metricsManager": "Metrics Manager~DB611",
		"password": "Password~DB580",
		"credentialCreateSuccess": "You have successfully created your credentials~DB596",
		"settings": "Settings~DB579",
		"restrictedFormatSelected": "[You do not have the capability to run reports in this format, but you can access reports that are saved in this format.~DB632]",
		"powerplayStudio": "PowerPlay Studio~DB612",
		"viewDetails": "View details~DB601",
		"showPassword": "Show password~DB584",
		"myPreferencesSlideoutLabel": "My Preferences~DB650",
		"passWordChangeSuccess": "You have successfully changed your password~DB592",
		"logging_level": "Logging level:~DB659",
		"analysisStudio": "Analysis Studio~DB606",
		"communityErrorMessage": "[Try again.  If the problem persists, contact your administrator.~DB648]",
		"cancel": "Cancel~DB633",
		"shareSetError": "This action cannot be performed before closing and reopening this view.~DB576",
		"passwordNotMatch": "[Oops, password does not match~DB589]",
		"xml": "XML~DB622",
		"xmlRestricted": "XML (Restricted)~DB623"
});